export const ImportsTableColumns = [
  {
    label: 'File name'
  },
  {
    label: 'Import created',
    width: '115px'
  },
  {
    label: 'Import type'
  },
  {
    label: 'ABM targeted'
  },
  {
    label: 'Status'
  },
  {
    label: 'Synced'
  },
  {
    label: 'Errors',
    width: '115px'
  }
]
